import { Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import Menu from "./Menu";

export default function MenuLayout() {
  return (
    <Flex w="100vw" bg="rgba(0,0,0, 0.1)" h="100vh" flexDirection="column">
      <Menu />
      <Flex
        w={{ base: "full", "2xl": "96%" }}
        minH="90vh"
        alignSelf="center"
        flexDirection="column"
        bg="#fff"
        overflowY={"scroll"}
        overflowX={"auto"}
      >
        <Outlet />
      </Flex>
    </Flex>
  );
}
